import { age, categorise, CATS, fmt } from './bamsShortsUtils';
import { InventoryCell } from './InventoryCell';

// Live tab: every out-of-stock scan in the last 24 hours, ranked by volume in the
// selected window. Intentionally does not tie to the weekly tabs.
export function LiveView({ live, liveAt, liveBusy, liveErr, liveModel, liveWin, onRefresh, setLiveWin }) {
    return (
        <div className="panel">
            <div className="bar" style={{ marginBottom: 8 }}>
                <p className="ptitle" style={{ flex: 1, margin: 0 }}>
                    Live — last 24 hours
                </p>
                <label className="inline" htmlFor="bams-livewin">
                    Rank by
                </label>
                <select
                    id="bams-livewin"
                    style={{ minWidth: 110 }}
                    value={liveWin}
                    onChange={(e) => setLiveWin(e.target.value)}
                >
                    <option value="1">Last 1h</option>
                    <option value="4">Last 4h</option>
                    <option value="24">Last 24h</option>
                </select>
                <button type="button" className="ghost" onClick={onRefresh} disabled={liveBusy}>
                    Refresh
                </button>
            </div>
            <div className="gap" style={{ marginTop: 0 }}>
                <b>This view does not tie to the weekly tabs.</b> It counts every out-of-stock scan in the last 24 hours
                regardless of pack week, so totals will not match Week view or Day &amp; line. That is by design — it
                answers &ldquo;what is breaking right now,&rdquo; not &ldquo;how did week N go.&rdquo; Auto-refreshes
                every 5 minutes while this tab is open.
            </div>
            {liveBusy && !live ? (
                <p className="pnote" style={{ marginTop: 12 }}>
                    <span className="spin" />
                    Pulling the last 24 hours…
                </p>
            ) : null}
            {liveErr ? (
                <div className="errbox" style={{ marginTop: 12 }}>
                    <b>Could not load the live view.</b> {liveErr}
                </div>
            ) : null}
            {liveModel && liveModel.top.length ? (
                <table className="live-table" style={{ marginTop: 12 }}>
                    <thead>
                        <tr>
                            <th className="item">Item</th>
                            <th>Site</th>
                            <th>1h</th>
                            <th>4h</th>
                            <th>24h</th>
                            <th>Last</th>
                            <th className="inv">Inventory</th>
                        </tr>
                    </thead>
                    <tbody>
                        {liveModel.top.map((r) => {
                            const stale = (r.minsSinceLast || 0) > 180;
                            const cat = CATS[categorise(String(r.itemName || ''))];
                            const fresh = (r.minsSinceLast || 0) <= 15;
                            const hot = (r.orders1h || 0) >= 10;
                            const iv = {
                                ats: r.atsUnits || 0,
                                qc: r.qcHoldUnits || 0,
                                unusable: r.unusableUnits || 0,
                            };
                            return (
                                <tr key={`${r.facility}|${r.brand}|${r.externalSku}`} className={stale ? 'stale' : ''}>
                                    <td className="item">
                                        <span className="cat" style={{ color: cat.col }}>
                                            {cat.lab}
                                        </span>
                                        {r.itemName || ''}
                                        <span className="skunum">{r.externalSku}</span>
                                    </td>
                                    <td className="sm">
                                        {r.facility} · {String(r.brand).replace(/_/g, ' ').slice(0, 2).toUpperCase()}
                                    </td>
                                    <td className={hot ? 'hot' : ''}>{fmt(r.orders1h)}</td>
                                    <td>{fmt(r.orders4h)}</td>
                                    <td style={{ color: 'var(--muted)' }}>{fmt(r.orders24h)}</td>
                                    <td className={`age${fresh ? ' fresh' : ''}`}>{age(r.minsSinceLast)}</td>
                                    <td className="inv">
                                        <InventoryCell v={iv} />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            ) : null}
            {liveModel && !liveModel.top.length && !liveBusy && !liveErr ? (
                <p className="pnote" style={{ marginTop: 12 }}>
                    No out-of-stock scans in the last {liveWin} hour
                    {liveWin === '1' ? '' : 's'}. The line may be between waves.
                </p>
            ) : null}
            {liveModel && liveModel.top.length ? (
                <p className="foot">
                    {fmt(liveModel.rows.length)} SKUs shorted in the last {liveWin}h · {fmt(liveModel.active)} scanned
                    in the last 15 minutes · pulled {liveAt ? liveAt.toLocaleTimeString() : '—'}. Rows dim after 3 hours
                    without a scan. Ranked by volume in the selected window, not recency — one scan a minute ago matters
                    less than forty in an hour.
                </p>
            ) : null}
        </div>
    );
}
